import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlockingLoaderService {
  private isBlockingSubject = new BehaviorSubject<boolean>(false);
  public isBlocking$: Observable<boolean> = this.isBlockingSubject.asObservable();

  setBlocking(isBlocking: boolean): void {
    this.isBlockingSubject.next(isBlocking);
  }

  show(): void {
    this.setBlocking(true);
  }

  hide(): void {
    this.setBlocking(false);
  }

  get isBlocking(): boolean {
    return this.isBlockingSubject.value;
  }
}
